import React,{Component} from 'react';
import './UpdatePassword.css';

import { 
    accountBackground, logo
} from '../../_utils/images';

// redux
import _ from 'lodash';
import { API_URL } from '../../_utils/config';
import Page from '@acri-tools/react-tools/components/Page/Page';
import Footer from '../../components/Footer/Footer';
import routes from '../../_utils/routes';
import Message from '@acri-tools/react-tools/components/Message/Message';
import request from '@acri-tools/react-tools/utils/request';
import { push_history } from '@acri-tools/react-tools/utils/global';

interface MyProps{
    history?:any,
    match?:any,

    // redux
    login?:any
}


class UpdatePassword extends Component<MyProps,{}>{
    state={
        password: '',
        confirm_password: '',

        message:'',
        messageType: 'warn',
    }

    render(){
        return (
        <Page 
            footer={<Footer/>}
            id="update-password"
            title="Update password"
            banner={{
                bannerImage:accountBackground,
                topBar:{
                    routes: routes,
                    logo: logo
                }
            }}
        >
            <div className="page-content">
                <div className="row-centered-column">
                    <div className="content-div"> 
                        <div className="title-2">Update Password</div>
                        <div className="form">
                            <div className="row-2">
                                <div className="form-field">
                                    <label>Password</label>
                                    <input 
                                        type="password" value={this.state.password} placeholder={"Password"}
                                        onKeyDown={(e)=>{this.onEnter(e, this.updatePassword)}} 
                                        onChange={(e)=>{ this.setState({ password: e.target.value }); }}/>
                                </div>
                                <div className="form-field">
                                    <label>Confirm Password</label>
                                    <input 
                                        type="password" value={this.state.confirm_password} placeholder={"Confirm Password"}
                                        onKeyDown={(e)=>{this.onEnter(e, this.updatePassword)}} 
                                        onChange={(e)=>{ this.setState({ confirm_password: e.target.value }); }}/>
                                </div>
                            </div>
                        </div>

                        <Message message={ this.state.message } type={ this.state.messageType }/>

                        <div className="custom-button green inverted alt" onClick={this.updatePassword}><i className="fas fa-key"/> UPDATE PASSWORD</div>
                    </div>
                </div>
            </div>
        </Page>
        );
    }

    onEnter = ( e:any, cb:any ) =>{
        if( e.keyCode === 13 ){
            if(cb) cb();
        }
    }

    updatePassword = () =>{
        let state:any = { ...this.state };
        for(let check of [ 'password', 'confirm_password' ]){
            if(!state[check]){
                this.setState({ message: `Missing ${check}`, messageType: 'warn' });
                return;
            }
        }

        let {
            password,
            confirm_password
        } = this.state;

        if( password !== confirm_password ){
            this.setState({ message: 'Passwords do not match', messageType: 'warn' });
        }
        else if(window.confirm(`Are you sure you want to update your password ?`)){
            this.setState({ updateEmailLoading:true });
            request(`${API_URL}/api/user-manager/v1/updatePassword/${this.props.match.params.token}`,{
                method:'post',
                responseType:'json',
                data:{
                    password,
                    confirm_password
                },
                serializer:'json'
            })
            .then((res:any)=>{
                push_history('/login')
            })
            .catch(e=>{
                this.setState({
                    loading:false,
                    message: e.response && e.response.data && e.response.data.error  ? e.response.data.error : 'An error has occured.',
                    messageType: 'error'
                })
            })
        }
    }

};

// export default App;
export default UpdatePassword;
